/** Display helpers shared across screens. */

export function initials(name: string): string {
  const words = (name || '').trim().split(/\s+/);
  const first = words[0]?.[0] ?? '?';
  const second = words[1]?.[0] ?? words[0]?.[1] ?? '';
  return (first + second).toUpperCase();
}

export function formatTokens(n: number): string {
  if (!Number.isFinite(n)) return '--';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
}

export function formatCost(usd: number): string {
  if (!Number.isFinite(usd)) return '--';
  // Sub-cent amounts are common per request, so keep four places there.
  return usd >= 0.01 ? `$${usd.toFixed(2)}` : `$${usd.toFixed(4)}`;
}

export function formatBytes(bytes: number): string {
  if (bytes >= 1_048_576) return `${(bytes / 1_048_576).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

const SYDNEY = 'Australia/Sydney';

export function formatTime(iso: string): string {
  return new Intl.DateTimeFormat('en-AU', {
    timeZone: SYDNEY,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(iso));
}

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('en-AU', {
    timeZone: SYDNEY,
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(iso));
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('en-AU', {
    timeZone: SYDNEY,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso));
}
